export default {
  methods: {
    getAllErrors(field = null) {
      return this.vErrors.all(field);
    },

    getFirstError(field) {
      return this.vErrors.first(field);
    },

    getAnyError(field) {
      return this.vErrors.any(field);
    },

    hasError(field) {
      return this.vErrors.has(field);
    },

    clearError(field = null) {
      if (field != null) this.vErrors.remove(field);
      else this.vErrors.clear();
    }
  }
};
